var _rect, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfigGreenBgBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#5062F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1666 7.58819C15.7251 6.50417 17.2749 6.50417 17.8334 7.58819L18.3295 8.55102C18.6651 9.20239 19.4221 9.51598 20.12 9.29269L21.1516 8.96263C22.313 8.59102 23.409 9.68696 23.0374 10.8484L22.7073 11.88C22.484 12.5779 22.7976 13.3349 23.449 13.6705L24.4118 14.1666C25.4958 14.7251 25.4958 16.2749 24.4118 16.8334L23.449 17.3295C22.7976 17.6651 22.484 18.4221 22.7073 19.12L23.0374 20.1516C23.409 21.313 22.313 22.409 21.1516 22.0374L20.12 21.7073C19.4221 21.484 18.6651 21.7976 18.3295 22.449L17.8334 23.4118C17.2749 24.4958 15.7251 24.4958 15.1666 23.4118L14.6705 22.449C14.3349 21.7976 13.5779 21.484 12.88 21.7073L11.8484 22.0374C10.687 22.409 9.59102 21.313 9.96263 20.1516L10.2927 19.12C10.516 18.4221 10.2024 17.6651 9.55102 17.3295L8.58819 16.8334C7.50417 16.2749 7.50417 14.7251 8.58819 14.1666L9.55102 13.6705C10.2024 13.3349 10.516 12.5779 10.2927 11.88L9.96263 10.8484C9.59102 9.68696 10.687 8.59102 11.8484 8.96263L12.88 9.29269C13.5779 9.51598 14.3349 9.20239 14.6705 8.55102L15.1666 7.58819Z",
    stroke: "#8CF295",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 15.5,
    r: 3,
    stroke: "#8CF295"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigGreenBgBlue);
export default __webpack_public_path__ + "static/media/configGreenBgBlue.d6f8ee3b4ba3c5a52f1717e0d15c03b6.svg";
export { ForwardRef as ReactComponent };